import { useBucket } from '@mc/experiments-react'
import { usePromotion } from '@mc/promo-utils'
import { useStaticData } from '@mc/static-data-react'
import { PLAN_Z_BOGO_FLAG_NAME } from '../constants'

export const useExperiment = () => {
  const { isGift } = useStaticData<{ isGift: boolean }>()
  const { isPromotionOn } = usePromotion({ isGift })
  const bucket = useBucket(PLAN_Z_BOGO_FLAG_NAME)

  const isEligible = !isGift && isPromotionOn

  return {
    bucket: isEligible ? bucket : undefined,
    isOn: isEligible && !!bucket,
    isVariant: isEligible && bucket?.startsWith('variant'),
  }
}
